import React, { useEffect, useState } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import Icon from '@material-ui/core/Icon'
import Menu from '@material-ui/core/Menu'
import { lookupSearchData } from '../../../../../nutritionix'
import iconFood from '../../../../../images/iconFood.png'
import iconDrink from '../../../../../images/iconDrink.png'
import iconDrinkGray from '../../../../../images/iconDrinkGray.png'

const AddItem = (props) => {
  const {search, updateSearch} = props
  const [tabSelection, updateTabSelection] = useState('general')
  const [anchor, updateAnchor] = useState('')
  const [loading, updateLoading] = useState(false)
  const [throttled, updateThrottled] = useState(false)
  const [failed, updateFailed] = useState(false)
  const [completedSearch, updateCompletedSearch] = useState('')
  const [brandData, updateBrandData] = useState([])
  const [naturalData, updateNaturalData] = useState([])

  const handleTypeChange = (val) => {
    props.updateItemType(val)
    updateAnchor('')
  }

  const doSearch = (query) => {
    if (query !== completedSearch && !loading && !throttled) {
      updateThrottled(true)
      setTimeout(() => updateThrottled(false), 300)
      updateLoading(true)
      lookupSearchData(props.proxyUserId, query).then((res) => {
        updateBrandData(res.data.branded)
        updateNaturalData(res.data.common)
        updateCompletedSearch(query)
        updateLoading(false)
      }).catch((err) => {
        console.log('lookupSearchData failed')
        console.log(err)
        updateFailed(true)
        updateLoading(false)
      })
    }
  }

  const handleSearchChange = (val) => {
    updateSearch(val)
    if (val !== '') {
      updateFailed(false)
      doSearch(val)
    }
  }

  useEffect(() => {
    if (search !== '' && search !== completedSearch && !loading && !throttled && !failed) {
      doSearch(search)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, completedSearch, loading, throttled, failed])

  const targetData = () => {
    if (props.itemType === 'food') {
      if (tabSelection === 'general') {
          return naturalData
      } else {
          return brandData
      }
    } else {
      return naturalData
    }
  }

  return (
    <Dialog
      className="tracker-fullscreen-dialog"
      open={props.open}
      onClose={() => {props.onClose(); updateSearch('');}}
      fullScreen
    >
      <div className="add-item-banner">
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%'}}>
          <button
            className="add-item-close"
            onClick={() => {props.onClose(); updateSearch('');}}
          >
            <Icon style={{color: '#FFFFFF'}}>arrow_back</Icon>
          </button>
          <div className="add-item-input-container">
            <div className="add-item-input-icon"><Icon>search</Icon></div>
            <input className="add-item-input" value={search} onChange={(e) => handleSearchChange(e.target.value)} placeholder="Search" />
            <button className="add-item-input-clear" onClick={() => updateSearch('')}><Icon>close</Icon></button>
          </div>
          <button className="add-item-custom-button" onClick={props.handleAddCustomPress}><Icon>edit</Icon></button>
        </div>
      </div>
      <div className="add-item-content">
        <div className="add-item-searchtype-container" style={{justifyContent: 'space-between'}}>
          <div className="add-item-searchtype">
            <button className={tabSelection === 'general' ? "active" : ""} onClick={() => updateTabSelection('general')}>General</button>
            <button className={tabSelection === 'branded' ? "active" : ""} onClick={() => updateTabSelection('branded')}>Branded</button>
          </div>
          <div className="add-item-itemtype">
            <button
              onClick={(e) => updateAnchor(e.currentTarget)}
            >
              <img src={props.itemType === 'food' ? iconFood : iconDrink} alt="icon" />
              <p>{props.itemType === 'food' ? 'Food': 'Alcohol'}</p>
              <Icon>expand_more</Icon>
            </button>
            <Menu
              keepMounted
              anchorEl={anchor}
              open={Boolean(anchor)}
              onClose={() => updateAnchor('')}
            >
              <button className="add-item-itemtype-menu-button" onClick={() => handleTypeChange('food')}><img src={iconFood} alt="food" />Food</button>
              <button className="add-item-itemtype-menu-button" onClick={() => handleTypeChange('alcohol')}><img src={iconDrinkGray} alt="alcohol" />Alcohol</button>
            </Menu>
          </div>
        </div>
        {search !== '' && (
          <div className="add-item-recent-list-wrapper">
            <div className="add-item-recents-label">Search</div>
            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 120 }}>
                <CircularProgress size={70} />
              </div>
            ) : (
              <>
                {targetData().map((item, index) => (
                  <button className="tracker-search-item" key={index} onClick={() => props.handleAddItemPress(item)}>
                    <div className="data-container">
                      <img className="tracker-thumbnail" src={item.photo.thumb} alt="thumbnail" />
                      <div className="data">
                        <p className="name">{item.food_name}</p>
                        {item.brand_name && <p className="unit">{item.brand_name}</p>}
                        <p className="unit">{(item.serving_qty + ' ' + item.serving_unit)}</p>
                      </div>
                    </div>
                  </button>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    </Dialog>
  )
}

export default AddItem